import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/onclusive-emblem-navigation.svg")